import { ReactNode } from 'react';
import Checkbox from '@/common/Checkbox';
import ArrowUpIcon from '@/assets/icons/arrow-up.svg?react';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import styles from './Accordion.module.scss';

interface AccordionProps {
  id: number; // club ID to use for checkbox events
  header: ReactNode;
  children: ReactNode;
  isOpen: boolean; // controlled open state
  showCheckbox: boolean;
  checked: boolean;
  /* eslint-disable no-unused-vars */
  handleOpenAccordion: (id: number) => void;
  handleCheckboxEvent: (id: number, isChecked: boolean) => void;
  /* eslint-enable no-unused-vars */
}

function ControlledAccordion({
  id,
  header,
  children,
  isOpen, // controlled
  showCheckbox,
  checked,
  handleOpenAccordion,
  handleCheckboxEvent,
}: AccordionProps) {
  const toggleAccordion = () => {
    handleOpenAccordion?.(id); // let parent handle the open state
  };

  // handle checkbox event
  const handleCheckboxChange = (isChecked: boolean) => {
    handleCheckboxEvent?.(id, isChecked); // let parent handle the checked state
  };

  return (
    <div className={styles.accordion} data-testid="tourbag-club-accordion">
      <div className={styles.header}>
        <span className={styles.headerText} onClick={toggleAccordion}>
          {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
          {header}
        </span>
        {showCheckbox && <Checkbox label="" checked={checked} onClick={handleCheckboxChange} />}
      </div>
      {isOpen && children}
    </div>
  );
}

export default ControlledAccordion;
